import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import { getTenantState } from '../../store/selectors';

function WindowTitle(props) {
  return (
    <Helmet>
      {/* eslint-disable */}
      <title>
        me3 {props.tenant.name}{' '}
        {props.children
          ? `- ${
              props.children.join ? props.children.join('') : props.children
            }`
          : ''}
      </title>
      <meta
        name="description"
        content="me3 is an online interactive major and career quiz that students can take to explore their interests, options and future."
      ></meta>
      {/* eslint-enable */}
    </Helmet>
  );
}

const mapStateToProps = (state) => {
  const tenant = getTenantState(state);

  return {
    tenant,
  };
};

export default withRouter(connect(mapStateToProps)(WindowTitle));
